import { skipToken } from "@reduxjs/toolkit/query";
import { Loader, LoaderStyle } from "@repo/ui/Loader/loader";
import type { FC } from "react";
import { Navigate } from "react-router";
import { useMostRecentlyUsedPlaybookByTeammateQuery } from "../api/entities/playbook.js";
import { appPaths } from "../app/appPaths.js";
import { selectTeammate } from "../features/teammate/teammateSlice.js";
import { useAppSelector } from "../hooks/hook.js";

/**
 * Home page for teammates with the TEAM_MEMBER role.
 * Redirects to the teammate's performance page once the playbook ID is available.
 */
export const TeamMemberHomePage: FC = () => {
  const teammate = useAppSelector(selectTeammate);

  const {
    data: playbook,
    isLoading,
    isError,
  } = useMostRecentlyUsedPlaybookByTeammateQuery(teammate?.id ?? skipToken);

  const playbookId = playbook?.id;

  if (!teammate || isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader style={LoaderStyle.ZOOMIES} />
      </div>
    );
  }

  if (isError || !playbookId) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">
            No playbook found
          </div>
        </div>
      </div>
    );
  }

  return (
    <Navigate
      to={appPaths.teammate.build({ playbookId, teammateId: teammate.id })}
      replace
    />
  );
};
